import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xml:space": "preserve",
  "fill-rule": "evenodd",
  "stroke-linejoin": "round",
  "stroke-miterlimit": "2",
  "clip-rule": "evenodd",
  viewBox: "0 0 32 40"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "m25.416 21.497 3.597 1.348a1 1 0 0 0 1.351-.936V10.091a1 1 0 0 0-1.351-.936l-4.948 1.855q.026.239.026.485v9.055l-1-.714v-8.341a3.587 3.587 0 0 0-3.586-3.586H8.404c-.548 0-1.067.123-1.531.343L2.581 5.186a1 1 0 0 0-1.162 1.628l28 20a1 1 0 0 0 1.162-1.628zM4.855 10.982a4 4 0 0 0-.037.513v9.01a3.587 3.587 0 0 0 3.586 3.586h11.101c.925 0 1.769-.351 2.405-.926z" }, null, -1)
  ])))
}
export default { render: render }